"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useElementAnalytics = exports.generateUUIDHof = void 0;
var react_1 = require("react");
var uuid_1 = require("../utils/uuid");
var useWebAnalytics_1 = require("./useWebAnalytics");
var env_1 = require("../utils/env");
var HierarchicalContext_1 = require("../HierarchicalContext/HierarchicalContext");
// TODO: Move this function to a utility file
function generateUUIDHof() {
    var uuid;
    return function () {
        if (!uuid) {
            uuid = (0, uuid_1.randomUUID)();
        }
        return uuid;
    };
}
exports.generateUUIDHof = generateUUIDHof;
/**
 * Enrich the given context fields with internal ADA React framework fields
 * @param eventFieldMap
 * @returns
 */
function enrichEventFieldMap(eventFieldMap) {
    var internalFields = {
        event_api: 'react-observe-element',
    };
    return __assign(__assign({}, eventFieldMap), internalFields);
}
/**
 * See [useElementAnalytics](https://gitlab.agodadev.io/full-stack/fe-data/analytics-data-acquisition/-/tree/master/packages/analytics-data-acquisition-react?ref_type=heads#useelementanalytics) for more information.
 *
 * @param actionTypes
 * @param idMap
 * @param eventFieldMap
 * @param options
 * @returns
 */
function useElementAnalytics(actionTypes, idMap, eventFieldMap, options) {
    var _a = options !== null && options !== void 0 ? options : {}, actionElementId = _a.actionElementId, optionalDependencyArray = _a.optionalDependencyArray, _b = _a.disableObservation, disableObservation = _b === void 0 ? false : _b;
    var webAnalytics = (0, useWebAnalytics_1.useWebAnalytics)();
    var generateUUID = (0, react_1.useMemo)(generateUUIDHof, []);
    var actionElementName = typeof idMap.action_element_name === 'function' ? idMap.action_element_name() : idMap.action_element_name;
    var dataElementId = (0, react_1.useMemo)(function () {
        var uniqueId = actionElementId ? actionElementId : generateUUID();
        return "".concat(actionElementName, "-").concat(uniqueId);
    }, [actionElementId]);
    var hierarchyId = (0, HierarchicalContext_1.useClosestHierarchyId)();
    (0, react_1.useEffect)(function () {
        if (disableObservation) {
            return;
        }
        if (webAnalytics) {
            webAnalytics.observeElement(actionTypes, idMap, enrichEventFieldMap(eventFieldMap), __assign(__assign({}, options), { actionElementId: dataElementId }));
        }
        else {
            var errorMessage = "Cannot observe element for ".concat(JSON.stringify(idMap, null, 2), ". Please ensure the component is wrapped with WebAnalyticsProvider and the webAnalytics is NOT undefined.\n            \nFor details on how to fix it, please refer to https://gitlab.agodadev.io/full-stack/fe-data/analytics-data-acquisition/-/tree/master/packages/analytics-data-acquisition-react?ref_type=heads#how-to-fix-cannot-observe-eventelement-for-please-ensure-the-component-is-wrapped-with-webanalyticsprovider-and-the-webanalytics-is-not-undefined-error");
            if ((0, env_1.isProduction)()) {
                console.error(errorMessage);
            }
            else {
                throw new Error(errorMessage);
            }
        }
    }, optionalDependencyArray !== null && optionalDependencyArray !== void 0 ? optionalDependencyArray : [webAnalytics, actionTypes, idMap, eventFieldMap, dataElementId]);
    var idProps = (0, react_1.useMemo)(function () {
        var props = {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'data-element-name': actionElementName,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'data-element-id': dataElementId,
        };
        if (hierarchyId) {
            props['data-context-id'] = hierarchyId;
        }
        return props;
    }, [actionElementName, dataElementId, hierarchyId]);
    return idProps;
}
exports.useElementAnalytics = useElementAnalytics;
